import React, { FC } from 'react';
import { FieldError } from '../../custom/FieldError';

interface Props {
	id: string;
	error?: string;
}

export const ErrorMessage: FC<Props> = ({ id, error }) => {
	return <FieldError id={id} message={error} />;
};
